import { render, staticRenderFns } from "./modalProductosIncluidos.vue?vue&type=template&id=2d04d3f5&"
import script from "./modalProductosIncluidos.vue?vue&type=script&lang=js&"
export * from "./modalProductosIncluidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports